
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import { useEffect } from 'react';
import useLatest from '../useLatest/index.js';
import { isFunction } from '../utils/index.js';
import isDev from '../utils/isDev.js';

var useUnmount = function (fn) {
  if (isDev) {
    if (!isFunction(fn)) {
      console.error("useUnmount expected parameter is a function, got ".concat(typeof fn));
    }
  }
  var fnRef = useLatest(fn);
  useEffect(function () {
    return function () {
      fnRef.current();
    };
  }, []);
};
var useUnmount$1 = useUnmount;

export { useUnmount$1 as default };
//# sourceMappingURL=index.js.map
